import {Injectable} from "@angular/core";
import {Assessment} from "../models/assessment";
import {AssessmentGroup} from "../models/assessment-group";
import {HTTPService} from "./http.service";
import {DacConfig} from "./dac-config.service";
import { AuthService } from "app/login/services/auth.service";
import { Capability } from "../models/capability";

interface AssessmentTokenQuota {
    assessment_uid:string;
    assessment_name:string;
    used_tokens:number;
    total_tokens:number;
    remaining_tokens:number;
}

@Injectable()
export class AssessmentTokenService {
    private assessmentQuotas:Map<string,AssessmentTokenQuota>;
    private tokensEnabled:boolean;

    constructor(
      // TODO: stephen replace $http here with our dac$http
      private _dac$http:HTTPService
      ,private authService:AuthService
      ,private dacConfig:DacConfig
    ) {
        this.authService.getLoginState().subscribe(state => {
            this.tokensEnabled = false;
            if (!this.dacConfig.isFeatureEnabled("assessments.tokens.enabled")) {
                return;
            }
            if (state.isLoggedIn && state.user) {
                this.tokensEnabled = state.user.hasCapability(Capability.CAN_BUY_TOKENS);
            }
        });
        
        // TODO: stephen if we remove tokens all together we want to remove this feature.
        if (this.dacConfig.isFeatureEnabled("assessments.tokens.enabled")) {
            this.tokensEnabled = true;
            this.authService.getCurrentUser().then(user => {
                if (!user.hasCapability(Capability.CAN_BUY_TOKENS)) {
                    this.tokensEnabled = false;
                }
            });
        }
        else
        {
            this.tokensEnabled = false;
        }
        this.assessmentQuotas = new Map<string,AssessmentTokenQuota>();
    }
    
    isTokensEnabled() {
        return this.tokensEnabled;
    }

    getGroupRemainingTokens(group:AssessmentGroup) {
        let numTests = group.Assessments ? group.Assessments.length : 0;
        if (numTests <= 0) {
        return 0;
        }

        var tokensRemaining = 9999999999; // obscenely large number
        // the smallest number of tokens in the group determines how much more the group
        // can be used.
        group.Assessments.forEach((a) => {
        let testCount = this.getRemainingTokens(a);
        tokensRemaining = Math.min(testCount, tokensRemaining);
        });
        return tokensRemaining;
    }

    hasTokens(assessment:Assessment) :boolean {
        return this.getRemainingTokens(assessment) > 0;
    }

    getTotalTokens(assessment:Assessment) : number {
        let quota = this.getItemForUid(assessment.uid);
        return quota ? quota.total_tokens : 0;
    }

    getUsedTokens(assessment:Assessment) : number {
        let quota = this.getItemForUid(assessment.uid);
        return quota ? quota.used_tokens : 0;
    }

    getRemainingTokens(assessment:Assessment) : number {
        let quota = this.getItemForUid(assessment.uid);
        return quota ? quota.remaining_tokens : 0;
    }

    consumeToken(assessmentUid:string) {
        // TODO: do we throw an exception if there are no tokens?
        let quota = this.getItemForUid(assessmentUid);
        if (quota) {
            quota.remaining_tokens -= 1;
            quota.used_tokens += 1;
        }
        else {
            console.error("No quota found for assessment with uid ",assessmentUid);
        }
    }

    freeToken(assessmentUid:string) {
        let quota = this.getItemForUid(assessmentUid);
        if (quota) {
            quota.remaining_tokens += 1;
            quota.used_tokens -= 1;
        }
        else {
            console.error("No quota found for assessment with uid ",assessmentUid);
        }
    }
    
    addTokensForGroup(group:AssessmentGroup, tokens:number) {
        group.Assessments.map(a => this.addTokens(a, tokens));
    }
    addTokens(assessment:Assessment, tokens:number) {
        let quota = this.getItemForUid(assessment.uid);
        if (quota) {
            quota.remaining_tokens += tokens;
        }
        else {
            console.error("No quota found for assessment with uid ",assessment.uid);
        }
    }

    loadAssessmentTokens() {
        return this._dac$http.get("/tokens/").then((result:any) => {
            let data = result.json() as AssessmentTokenQuota[];
            data.forEach((item) => {
                this.assessmentQuotas[item.assessment_uid] = item;
            });
        });
    }

    private getItemForUid(uid:string) : AssessmentTokenQuota {
        return this.assessmentQuotas[uid];
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/assessment-token.service.ts